import React from 'react';
import { NextLink } from '@mantine/next';
import { Button, Container, Modal, Text } from '@mantine/core';
import { AppRoutes, getPageRoute } from '@core/router/AppRoutes';
import useIsMounted from '@hooks/use-is-mounted';
import useDxbTheme from '@hooks/use-dxb-theme';
import useAppData from '@hooks/use-app-data';
import { useRouter } from 'next/router';
import useStyles from './AuthModal.styles';


interface Props {
    open: boolean;
    onClose: () => void;
}

export const AuthModal: React.FC<Props> = ({
                                               open,
                                               onClose
                                           }) => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();
    const { isDark, theme } = useDxbTheme();

    const router = useRouter();
    const { slug } = router.query
    const { setLastPage } = useAppData();


    return isMounted && (
        <Container>
            <Modal
                className={classes.modalWrapper}
                overlayColor={isDark ? theme.colors.dark[9] : theme.colors.gray[2]}
                overlayOpacity={0.55}
                overlayBlur={3}
                centered={true}
                withCloseButton={true}
                title="Would you like to make a booking?"
                onClose={() => onClose()}
                opened={open}
            >
                <Text align="center" size="sm" color="orange">Please log in or sign up to make bookings.</Text>
                <Button
                    className={classes.modalButtons}
                    component={NextLink}
                    title="Log in to your account"
                    variant="filled"
                    radius="xs"
                    mt="xl"
                    fullWidth={true}
                    href={AppRoutes.LOGIN}
                    onClick={() => {
                        //setLastRoute(getPageRoute(AppRoutes.PROPERTIES, slug.toString()));
                        setLastPage(getPageRoute(AppRoutes.PROPERTIES, slug.toString())); // TODO: FLOW TEST
                    }}
                >
                    Log in to your account
                </Button>

                <Button
                    className={classes.modalButtons}
                    component={NextLink}
                    title="Sign up for an account"
                    variant="filled"
                    radius="xs"
                    mt="xl"
                    fullWidth={true}
                    href={AppRoutes.REGISTER}
                    onClick={() => {
                        //setLastRoute(getPageRoute(AppRoutes.PROPERTIES, slug.toString()));
                        setLastPage(getPageRoute(AppRoutes.PROPERTIES, slug.toString())); // TODO: FLOW TEST
                    }}
                >
                    Create an account...
                </Button>

                {/*<Button
                    className={classes.modalButtons}
                    color="red"
                    radius="xs"
                    mt="xl"
                    pt="md"
                    pb="md"
                    fullWidth={true}
                    onClick={() => onClose()}
                >
                    Ops! I made a mistake
                </Button>*/}

            </Modal>
        </Container>
    )

}
